<div class="side-menu-certificate">
  <div class="h5-lg-blue">
    {{ 'nav.certificate.title' | translate }}
  </div>
  <p class="gs1-little gs1-color-ui-6 side-menu-certificate__description">
    {{ 'nav.certificate.description' | translate }}
  </p>

  <div class="side-menu-certificate__checkboxes">
    <gs1-checkbox-group [basicStyle]="true" [hasState]="false"> 
    <gs1-checkbox
        [basicStyle]="true"
      [checked]="frSelected()"
      [id]="'sideMenuCertFrSelect'"
      (change)="toggleFr()"
      [label]="'nav.certificate.fr' | translate"
    />
    <gs1-checkbox
    [basicStyle]="true"
      [checked]="enSelected()"
      [id]="'sideMenuCertEnSelect'"
      (change)="toggleEn()"
      [label]="'nav.certificate.en' | translate"
    />
  </gs1-checkbox-group>
  </div>

  <div
    class="side-menu-certificate__action"
    [matTooltip]="disabledReason()"
    [matTooltipDisabled]="isEnabled()"
    matTooltipPosition="above"
  >
    <button
      gs1Button
      appearance="clear"
      [color]="'blue'"
      [name]="'download-side-menu-certificate'"
      [thin]="true"
      [margin]="false"
      [pending]="loading() || companyLoading()"
      [disabled]="!isEnabled() || loading() || companyLoading()"
      (click)="download()"
    >
        <i class="bi bi-download"></i>
      {{ 'nav.certificate.download' | translate }}
    </button>
  </div>
</div>
